import { AuthorizeConfirmationPayload, SignInPayload, SignUpPayload } from './core.interfaces';

export class NavigateToRecruitee {
  public static type: string = '[Core] NavigateToRecruitee';
}

export class LogOutWithRecruitee {
  public static type: string = '[Core] LogOutWithRecruitee';
}

export class LogOut {
  public static type: string = '[Core] LogOut';
}

export class SignInWithRecruitee {
  public static type: string = '[Core] SignInWithRecruitee';
}

export class SignIn {
  public static type: string = '[Core] SignIn';

  constructor(public payload: SignInPayload) {}
}

export class SignUp {
  public static type: string = '[Core] SignUp';

  constructor(public payload: SignUpPayload) {}
}

export class AuthorizeConfirmation {
  public static type: string = '[Core] AuthorizeConfirmation';

  constructor(public payload: AuthorizeConfirmationPayload) {}
}

export class ToggleForeignAdmin {
  public static type: string = '[Core] ToggleForeignAdmin';
}
